<template>
    <div class="article">
        <div class="article-container">
            <div class="article-title">
                <div class="name-wrapper">
                    <h3>성적표</h3>
                </div>
            </div>
            <div class="article-demonstrate">
                <li class="demonstration">학생의 채점 결과를 입력하세요.</li>
            </div>
            <div v-if="userLevel > 1">
                <el-select @change="getList" v-model="selectedStudent" size="small" style="width: 320px; float: right" placeholder="학생 선택">
                    <el-option
                            v-for="item in studentList"
                            :key="item.userId"
                            :label="`${item.name} (${item.userId})`"
                            :value="item.userId">
                    </el-option>
                </el-select>
            </div>
            <div class="article-table">
                <template>
                    <el-table
                        @row-click="clicked"
                        style="cursor: pointer"
                        :data="tableData"
                        size="small"
                        empty-text="채점결과가 없습니다.">
                        <el-table-column
                                prop="grade"
                                width="60"
                                label="학년">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                width="230"
                                label="대단원">
                        </el-table-column>
                        <el-table-column
                            prop="questionName"
                            width="300"
                            label="소단원">
                        </el-table-column>
                        <el-table-column
                            prop="score"
                            width="80"
                            label="점수">
                        </el-table-column>
                        <el-table-column
                            prop="date"
                            width="100"
                            label="채점 날짜">
                        </el-table-column>
                        <el-table-column
                            width="70"
                            label="삭제">
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="deleteScore(scope.row.scoreId)">삭제</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="write-buttons">
                <el-button type="primary" size="small" @click="goWrite">등록하기</el-button>
            </div>
            <div class="pagination">
                <el-pagination
                        layout="prev, pager, next"
                        @current-change="pagination"
                        :total="listCount">
                </el-pagination>
            </div>
        </div>

        <el-dialog
                :title="`성적 등록 (${selectedStudent})`"
                :visible.sync="dialogVisible"
                width="30%">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="학년">
                    <el-select
                            v-model="selectedGrade"
                            placeholder="학년"
                            @change="clickGrade(selectedGrade)">
                        <el-option-group>
                            <el-option
                                    label="초1"
                                    value="초1">
                            </el-option>
                            <el-option
                                    label="초2"
                                    value="초2">
                            </el-option>
                            <el-option
                                    label="초3"
                                    value="초3">
                            </el-option>
                            <el-option
                                    label="초4"
                                    value="초4">
                            </el-option>
                            <el-option
                                    label="초5"
                                    value="초5">
                            </el-option>
                            <el-option
                                    label="초6"
                                    value="초6">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <el-form-item label="대단원">
                    <el-select
                            v-model="chapterValue"
                            placeholder="대단원"
                            @change="changeChapter">
                        <el-option-group
                                v-for="group in chapterOptions"
                                :key="group.label"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <el-form-item label="소단원">
                    <el-select v-model="problemValue"
                               placeholder="소단원">
                        <el-option
                                v-for="item in problemOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="점수">
                    <el-input v-model="selectedScore" style="width:217px"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitScore">등록</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Variables from "@/controller/variables";
    export default {
        name: "score.vue",
        data() {
            return {
                selectedScore: 0,
                selectedGrade: '초1',
                chapterValue: '',
                chapterOptions: [],
                problemValue: '',
                problemOptions: [],
                selectedStudent: null,
                studentList: [],
                listCount: 0,
                tableData: [],
                dialogVisible: false
            }
        },
        mounted() {
            this.$http.defaults.headers['x-access-token'] = this.token;
            this.getStudentList()
            if (this.userLevel === '1') this.selectedStudent = this.username
            this.getList()
            this.clickGrade('초1')
        },
        methods: {
          async clicked(row) {
            this.$store.commit('setMode', {mode: 0});
            let problemInfo = (await this.$http.get(`/api/questions/get?id=${row.chapter_id}`)).data
            let vars = new Variables()
            let data = vars.convert(problemInfo)
            let problemId = (await this.$http.post(`/api/make`, data)).data.id;
            this.$router.push(`/testviewer/${problemId}`).catch(() => {})
          },
            deleteScore(scoreId) {
              if (confirm('정말로 삭제하시겠습니까?')) {
                this.$http.post(`/api/score/delete`, {scoreId: scoreId})
                    .then(() => {
                      this.getList()
                    })
              }
            },
            clickGrade(gradeString) {
                let grade;
                this.grade = grade;
                if (gradeString.indexOf('초') !== -1) {
                    grade = gradeString.replace('초', '');
                } else {
                    grade = Number(gradeString.replace('중', '')) + 6;
                }
                this.$store.commit('setGrade', {
                    grade: grade
                });

                this.$http.get(`/api/chapter/${this.inform.grade}`)
                    .then((result) => {
                        this.chapterOptions = [
                            {
                                label: "1학기",
                                options: []
                            },
                            {
                                label: "2학기",
                                options: []
                            }
                        ];
                        for (const data of result.data) {
                            const temp = {
                                value: `${data.id}`,
                                label: `${data.name}`
                            };
                            if (data.semester.indexOf("1") !== -1) this.chapterOptions[0]['options'].push(temp);
                            else this.chapterOptions[1]['options'].push(temp);
                        }
                        console.log(this.chapterOptions)
                        this.chapterValue = this.chapterOptions[0]['options'][0].value;
                        this.problemValue = '';
                        this.problemOptions = [];

                        this.changeChapter();
                    })
            },
            changeChapter() {
              console.log(this.chapterValue)
                this.$http.get(`/api/questions/info?chapter_id=` + this.chapterValue)
                    .then((result) => {
                        this.problemOptions = [];
                        this.problemValue = '';
                        for (const data of result.data) {
                            const temp = {
                                value: data.id,
                                label: data.questionName
                            };
                            this.problemOptions.push(temp);
                        }
                    })
            },
            changeProblem() {
                this.$store.commit('setProblem',
                    {
                        problem: this.problemValue
                    });
                const { grade, semester, chapter, problem } = this.inform;
                const problemId = `${grade}${semester}${chapter}${problem}`;
                this.$http.get(`/api/make/${grade}/${semester}/${chapter}/${problem}`);
                this.$http.get(`/api/problemId/${problemId}`)
                    .then((result) => {
                        this.$router.push(`/testviewer/${result.data.problemId}`).catch(() => {})
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            },
            getStudentList() {
                this.$http.get(`/api/score/studentList`)
                    .then((result) => {
                        this.studentList = result.data;
                    })
            },
            goWrite() {
                if (this.selectedStudent === null) {
                    alert('학생을 선택해주세요.')
                    return
                }
                this.dialogVisible = true
            },
            submitScore() {
                this.$http.post('/api/score/insert', {
                    userId: this.selectedStudent,
                    score: this.selectedScore,
                    chapter_id: this.problemValue
                }).then(() => {
                    this.getList()
                    this.dialogVisible = false
                })
                .catch((err) => {
                    console.log(err);
                })
            },
            getList() {
                this.$http.get('/api/score/list?userId='+this.selectedStudent)
                    .then((result) => {
                        this.tableData = result.data.data;
                        this.tableData.map(r => r.date = r.date.split('T')[0])
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            },
            pagination(page) {
                this.getList(page);
            }
        },
        computed: mapGetters({
            inform: "getState",
            userLevel: 'getUserLevel',
            average: "getAverage",
            token: "getToken",
            username: "getUsername"
        })
    }
</script>

<style scoped>
    .article-list {
        max-width: 874px;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;
        padding: 15px;
    }
    .article-container {
        width: 100%;
        text-align: center;
        margin: 0 auto;
        display: inline-block;
    }
    .score-title {
        width: 100%;
        border-bottom: 2px solid #bcbcbc;
        margin: 0 auto;
        display: inline-block;
    }
    name-wrapper {
        float: left;
        line-height: 22px;
        letter-spacing: -1px;
        display: inline-block;
    }
    name-wrapper > h3 {
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .article-demonstrate {
        margin: 0 auto;
        min-width: 230px;
        display: table-caption;
        vertical-align: top;
    }
    .demonstration {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 10px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
        vertical-align: top;
    }
    .average {
        display: list-item;
        text-align: -webkit-match-parent;
        margin-top: 30px;
        margin-bottom: 4px;
        color: #888;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: -.3px;
        font-family: 나눔고딕,NanumGothic,system,sans-serif;
        list-style: none;
        float: left;
        vertical-align: top;
    }
    .score-table {
        width: 100%;
        margin: 30px auto;
        display: inline-block;
    }
    .pagination{
        display: inline-block;
        width: 100%;
    }
    .write-buttons > button {
        float: right;
    }
</style>